export const whiteQuote = 'https://acko-cms.ackoassets.com/White_Quotes_bd65ba938c.svg'
export const playIcon = 'https://acko-cms.ackoassets.com/Play_icon_56b85de420.svg'

export const seeMoreCta = 'See more reviews'
export const seeMoreLoadingCta = 'Loading...'

export const OnlineRatingsMock = {
  appStore: {
    logo: 'https://acko-cms.ackoassets.com/Apple_Icon_4c5d8c3cf0.svg',
    rating: 4.8,
    subTitle: 'App store rating',
  },
  playStore: {
    logo: 'https://acko-cms.ackoassets.com/Play_store_icon_7005c0f4bd.svg',
    rating: 4.6,
    subTitle: 'Play store rating',
  },
  google: {
    logo: 'https://acko-cms.ackoassets.com/Google_icon_7595c0aa3d.svg',
    rating: 4.6,
    subTitle: 'Google rating',
  },
}

export const CustomerVideoOptionsMock = {
  videoThumbnailUrl: 'https://acko-cms.ackoassets.com/Customer_Video_Thumbnail_6d68d5db98.webp',
  videoUrl: 'https://acko-cms.ackoassets.com/Customer_Video_d8fcb43a1b.mp4',
  customerName: 'Sundereshan',
  customerTitle: 'ACKO customer since 2016',
  story: "I raised a claim on the app, uploaded a few photos. Boom, it's done! ACKO made my claim super easy.",
}

export const CustomerStoryDescriptionMock = {
  title: 'Customer stories',
  description:
    'Insurance you can always trust. Don’t just take our word for it. See what real ACKO customers have to say.',
}

export const CustomerStoriesListHeadingMock = {
  title: 'Stories that speak for ACKO',
  description: 'Our customers say it better than we ever could. Read about their moments with ACKO.',
}
